import * as React from 'react';

import { translate as t } from '../../../../translations';
import { Style as StyleService } from '../../../../services/styles';
import { withOnChangeProperty } from '../../../../utils';
import { ColorPalette, Tab, Tabs } from '../../../ui';
import { BackgroundImage } from './BackgroundImage';
import { ShadowSettings } from '../ShadowSettings';
import { ThemeSettings } from '../ThemeSettings';

/**
 * Renders a form that enables editing background/shadow/theme settings.
 */
export class BackgroundSettings extends React.PureComponent {
    constructor(props) {
        super(props);
        withOnChangeProperty(this);
    }

    render() {
        const {
            value = {},
            name: key,
            onChange,
            shadow = false,
            theme = false,
            state,
            states,
            onChangeState,
            defaults,
            propName = 'backgroundColor',
        } = this.props;
        const style = StyleService.getCurrent('global').properties;

        return (
            <Tabs state={state} states={states} onChangeState={onChangeState}>
                <Tab id="color" label={t('STYLE.COLOR')}>
                    <ColorPalette
                        value={value.backgroundColor || defaults[propName]}
                        name="backgroundColor"
                        onChange={this.onChangeProperty}
                        hasClearChoice
                        choices={style.colors}
                        primary={style.primary}
                        accent={style.accent}
                    />
                </Tab>
                <Tab id="image" label={t('STYLE.IMAGE')}>
                    <BackgroundImage value={value} name={key} onChange={onChange} defaults={defaults}/>
                </Tab>
                {shadow && (
                    <Tab id="shadow" label={t('STYLE.SHADOW')}>
                        <ShadowSettings value={value} name={key} onChange={onChange} defaults={defaults} />
                    </Tab>
                )}
                {theme && (
                    <Tab id="theme" label={t('STYLE.THEME')}>
                        <ThemeSettings value={value.theme} name="theme" onChange={this.onChangeProperty} />
                    </Tab>
                )}
            </Tabs>
        );
    }
}
